import { useState } from "react";
import PageTemplate from "../components/PageTemplate";
import PhotoAlbum from "react-photo-album";
import "react-photo-album/rows.css";
import "react-photo-album/columns.css";
import "react-photo-album/masonry.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Fullscreen, Slideshow, Download } from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Container from "../components/Container";
import Content from "../components/Content";
import engagementPhotos from '../engagementPhotos.json';
import engagementThumbnailsPhotos from '../engagementThumbnailsPhotos.json';
import { Link } from 'react-router-dom';
import PageFade from "../motions/PageFade";
import { useEffect } from 'react';

function EngagementPhotos() {
  console.log("EngagementPhotos rendered");

  useEffect(() => {
    console.log("EngagementPhotos mounted");

    return () => {
      console.log("EngagementPhotos unmounted");
    };
  }, []);

  const [index, setIndex] = useState(-1);

  return (
    <PageFade>
      <PageTemplate minor={true} title="Engagement Shoot Photos" textColor="text-gold">
        <Content>
          <div>
            <p className="mb-10">
              Our engagement shoot took place in December 2024 at the Library of Congress, located in Washington, D.C., the city where we met and began building our life together.
            </p>
            <p>
              <Link to="/gallery" className="text-gold hover:underline">
                Back to Wedding Gallery
              </Link>
            </p>
          </div>
        </Content>
        <Container>
          <div>
            <PhotoAlbum
              photos={engagementThumbnailsPhotos}
              layout="columns"
              onClick={({ index }) => setIndex(index)}
            />

            <Lightbox
              slideshow={{ delay: 5000 }}
              slides={engagementPhotos}
              open={index >= 0}
              index={index}
              close={() => setIndex(-1)}
              plugins={[Fullscreen, Slideshow, Download]}
              styles={{
                container: {
                  backgroundColor: "rgba(0, 0, 0, 0.9)"
                },
              }}
            />
          </div>
          <p className="mt-10">
            <Link to="/gallery" className="text-gold hover:underline">
              Back to Wedding Gallery
            </Link>
          </p>
        </Container>
      </PageTemplate>
    </PageFade>
  );
}

export default EngagementPhotos;
